import { SET_RESERVATION } from '../actions/type'
import moment from 'moment'

const initialState = {
    reservationList: [],
    reservationItems: [],
    latestCreateReservation: {},
    reservationDetail: {},
    activeItem: null,
    calendarDate: moment().format('MM/Y')
}

const reservation = (state = initialState, action) => {
    switch (action.type) {
        case SET_RESERVATION: {
            const payload = action.payload;
            return { ...state, ...payload };
        }
        default:
            return state
    }
}

export default reservation